import { render, staticRenderFns } from "./MaleRank.vue?vue&type=template&id=06cf9081&scoped=true&"
import script from "./MaleRank.vue?vue&type=script&lang=js&"
export * from "./MaleRank.vue?vue&type=script&lang=js&"
import style0 from "./MaleRank.vue?vue&type=style&index=0&id=06cf9081&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf9081",
  null
  
)

export default component.exports